// extracted by mini-css-extract-plugin
module.exports = {"spiderLegLine":"styles_spiderLegLine__jsakB","active":"styles_active__89ZXD","spiderLegPin":"styles_spiderLegPin__xqDUN","pinImage":"styles_pinImage__QNcjL"};